import { SELECIONAR_ENDERECO_DESTINATARIO } from '../../actions/types'

const initialState = undefined

export default function reducerEnderecoDestinatario (state = null, action = initialState) {
  switch (action.type) {
    case SELECIONAR_ENDERECO_DESTINATARIO: {
      return action.payload;
    }

    default: {
      return state
    }
  }
}
